module.exports = __webpack_public_path__ + "img/carshina22_03.e50a7ac3.jpg";